import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Utils from "../../lib/Utils";
import Login from "./Login";
import Register from "./Register";

const RegisterLogin = () => {

    const [registred, setRegistred] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if(Utils.CheckUser()){
            history.push('')
        }
    }, [])

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ "min-height" : "calc(100vh - 100px)" }}>
            <div className="container-fluid">
                {registred ? 
                    <div className="alert register-alert">
                        <h3>Registred successfully</h3>
                        <p>
                            Thank you for registring, an email was sent to your email <b>{registred.email}</b>. 
                            Click on the link in the email to activate your account
                        </p>
                        <Link to={'/'}><button className="btn-black">Return to Home</button></Link>
                    </div>
                    :
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-6 login-col">
                            <Login header={true}/>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 register-col">
                            <Register onRegister={setRegistred}/>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export { RegisterLogin };